module.exports = __webpack_public_path__ + "fonts/fontello.6ef91a6.woff2";